import { render, staticRenderFns } from "./AnswerDetail.vue?vue&type=template&id=89d60886"
import script from "./AnswerDetail.vue?vue&type=script&lang=js"
export * from "./AnswerDetail.vue?vue&type=script&lang=js"
import style0 from "./AnswerDetail.vue?vue&type=style&index=0&id=89d60886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports